import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { PaginatorInterfaceState } from '../../store/state/paginator.state';
import { PaginatorInterface } from '../../models/paginator.interface';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.css'],
  standalone: false
})
export class PaginatorComponent implements OnInit {

  paginator: PaginatorInterface;
  totalItemsPerPage: number = 5;
  totalPagesNumber: number = 0;
  brand?: string;

  pages: Array<any> = [];

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.store.pipe(select(ConstsHelper.REDUCER_PAGINATOR)).subscribe((response: PaginatorInterfaceState) => {
      if (response.paginator != null) {
        this.paginator = response.paginator;
        this.calculatePagesNumber();
      }
    });
    this.brand = environment.data.brand;
    this.calculatePagesNumber();
  }

  paginate(page: number) {
    if (page <= this.totalPagesNumber && page > 0) {
      this.paginator.currentSelectedPage = page;
      if (this.paginator.type === 'msisdn') {
        this.store.dispatch(new this.paginator.action(this.paginator.selectedLine.phoneNumber, page, this.totalItemsPerPage));
      } else if (this.paginator.type === 'account' || this.paginator.type === 'bill' || this.paginator.type === 'payment') {
        this.store.dispatch(new this.paginator.action(this.paginator.type, page, this.totalItemsPerPage));
      } else if (this.paginator.type === 'communication') {
        this.store.dispatch(new this.paginator.action(this.paginator.selectedLine.phoneNumber, this.paginator.month, page, this.totalItemsPerPage));
      } else {
        this.store.dispatch(new this.paginator.action(page, this.totalItemsPerPage));
      }
      this.paginatorContent();
    }
  }

  setItemsPerPage(event) {
    this.totalItemsPerPage = event.target.value;
    this.calculatePagesNumber();
    this.paginate(1);
  }

  private calculatePagesNumber() {
    if ((this.paginator.totalItems % this.totalItemsPerPage) === 0) {
      this.totalPagesNumber = Math.trunc(this.paginator.totalItems / this.totalItemsPerPage);
    } else {
      this.totalPagesNumber = Math.trunc(this.paginator.totalItems / this.totalItemsPerPage) + 1;
    }
    this.paginatorContent();
  }

  private paginatorContent() {
    const pages = [];
    if (this.totalPagesNumber > 0) {
      for (let i = -2; i <= 4 && pages.length < 5; i++) {
        if (pages.indexOf(this.paginator.currentSelectedPage + i) === -1 && (this.paginator.currentSelectedPage + i) > 0 && (this.paginator.currentSelectedPage + i) <= this.totalPagesNumber) {
          pages.push(this.paginator.currentSelectedPage + i);
        } else {
          if (this.paginator.currentSelectedPage - i > 0 && pages.indexOf(this.paginator.currentSelectedPage - i) === -1 && (this.paginator.currentSelectedPage - i) <= this.totalPagesNumber) {
            pages.push(this.paginator.currentSelectedPage - i);
          }
        }
      }
      this.pages = pages.sort(function(a, b) {
        return a - b;
      });
    }
  }
}
